if (typeof StorePrices !== 'function') {
	class StorePrices extends HTMLElement {
		constructor() {
			super();

			this.variants = JSON.parse(this.dataset.variants);
			this.defaultVariant = JSON.parse(this.dataset.defaultVariant);

			const widgetIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				this.updatePrices();
			};
			new IntersectionObserver(widgetIntersection.bind(this), { rootMargin: '0px 0px 50px 0px' }).observe(this);

			this.storeSelector = document.querySelector('store-selector');
			// this.predictiveSearchResults = document.querySelectorAll('[data-js-search-results]');

			window.addEventListener('load', () => {
				if (this.storeSelector) {

					this.storeSelector.addEventListener('storechanged', (e) => {
						this.updatePrices();

						// if (this.predictiveSearchResults.length > 0) {
						// 	this.updatePricesOnPredictiveSearch();
						// }
					});
				}
			});
		}

		updatePrices() {
			const selectedStore = localStorage.getItem('selected-store');
			const min_price = '';
			let getVariantsByType = {};
			const typeValues = this.variants.map((variant) => variant.type);
			const priceValues = this.variants.map((variant) => variant.price);
			const variantsLength = this.variants.length;

			if (typeValues.includes('Shipping') || typeValues.includes('Pickup')) {
				if (!this.defaultVariant) {
					if (selectedStore === 'shipping') {
						getVariantsByType = this.variants.filter((price) => price.type.includes('Shipping'));
					} else {
						getVariantsByType = this.variants.filter((price) => price.type.includes('Pickup'));
					}
				} else {
					getVariantsByType = this.variants.filter((price) => price.type === 'Default Title');
				}

				const minVariant = getVariantsByType.reduce((minObj, obj) => {
					const currentPrice = Number(obj.price);
					const minPrice = Number(minObj.price);

					return currentPrice < minPrice ? obj : minObj;
				});

				if (variantsLength > 2) {
					this.innerText = `From ${this._formatMoney(minVariant.price, KROWN.settings.shop_money_format)}`;
				} else {
					this.innerText = `${this._formatMoney(minVariant.price, KROWN.settings.shop_money_format)}`;
				}
			} else {
				const minVariant = this.variants.reduce((minObj, obj) => {
					const currentPrice = Number(obj.price);
					const minPrice = Number(minObj.price);

					return currentPrice < minPrice ? obj : minObj;
				});

				if (variantsLength > 2) {
					this.innerText = `From ${this._formatMoney(minVariant.price, KROWN.settings.shop_money_format)}`;
				} else {
					this.innerText = `${this._formatMoney(minVariant.price, KROWN.settings.shop_money_format)}`;
				}
			}
		}

		// updatePricesOnPredictiveSearch() {
		// 	this.predictiveSearchResults.forEach((result) => {
		// 		const resultStorePrices = result.querySelectorAll('store-prices');

		// 		resultStorePrices.forEach((storePrice) => {
		// 			storePrice.updatePrices();
		// 		});
		// 	});
		// }

		_formatMoney(cents, format) {
			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}

			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;

			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';

				if (isNaN(number) || number === null) {
					return 0;
				}

				number = (number / 100.0).toFixed(precision);

				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
				const centsAmount = parts[1] ? decimal + parts[1] : '';

				return dollarsAmount + centsAmount;
			}

			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}

			return formatString.replace(placeholderRegex, value);
		}
	}

	if (typeof customElements.get('store-prices') == 'undefined') {
		customElements.define('store-prices', StorePrices);
	}
}
